let r = {
  bold: {
    parseDOM: [
      { tag: "strong" },
      { tag: "b" },
      {
        style: "font-weight",
        getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null
      }
    ],
    toDOM() {
      return ["b", 0];
    }
  },
  italic: {
    parseDOM: [{ tag: "i" }, { tag: "em" }, { style: "font-style=italic" }],
    toDOM() {
      return ["i", 0];
    }
  },
  code: {
    parseDOM: [{ tag: "code" }],
    toDOM() {
      return ["code", 0];
    },
    inclusive: !1
  },
  anchor: {
    parseDOM: [
      {
        tag: "a",
        getAttrs(t) {
          return { href: t.getAttribute("href") };
        }
      }
    ],
    attrs: { href: { default: "" } },
    inclusive: !1,
    // Whether this mark should be active when the cursor is positioned at its end
    toDOM(t) {
      return ["a", { href: t.attrs.href }, 0];
    }
  },
  underline: {
    parseDOM: [{ tag: "u" }],
    toDOM() {
      return ["u", 0];
    }
  },
  span: {
    parseDOM: [
      {
        tag: "span",
        getAttrs(t) {
          return { style: t.getAttribute("style") };
        }
      }
    ],
    attrs: { style: { default: "" } },
    toDOM(t) {
      let { style: e } = t.attrs;
      return ["span", { style: e }, 0];
    }
  },
  deletion: {
    parseDOM: [{ tag: 'mark[data-mark-type="deletion"]' }],
    toDOM() {
      return ["mark", { "data-mark-type": "deletion" }, 0];
    },
    serializable: !1
  },
  insertion: {
    parseDOM: [{ tag: 'mark[data-mark-type="insertion"]' }],
    toDOM() {
      return ["mark", { "data-mark-type": "insertion" }, 0];
    },
    serializable: !1
  }
};
export {
  r as markSpecs
};
